<template>
  <div class="hm-card landing blue-header-banner">
    <div class="header-banner">
      <h2>
        Do You Have Medicaid?
        <span class="tooltip-icon" v-tooltip="'This is a joint federal and state program that helps with medical costs for citizens with limited income and resources. Most costs are covered if you qualify for Medicare and Medicaid.'">
          <img src="//hm-lis.herokuapp.com/img/svg/info-circle-solid.svg" alt="image">
        </span>
      </h2>
      <p>If you and/or your spouse have coverage through your state’s Medicaid program, select “I Have Medicaid”.</p>
    </div>
    <div class="max-w">
      <div class="large-icons-block">
        <SuiButton basic color="grey" class="large-icon-square" @click="onClickHasMedicaid">
          <span>I Have Medicaid</span>
          <div class="img check-on"></div>
        </SuiButton>
        <SuiButton basic color="grey" class="large-icon-square" @click="onClickDontHasMedicaid">
          <span>I Do Not Have Medicaid</span>
          <div class="img check-off"></div>
        </SuiButton>
      </div>
    </div>
  </div>
</template>

<script>
  import Medicaid from '@/components/small/Medicaid';

  export default {
    extends: Medicaid,
  }
</script>

<style lang="scss" scoped>

  .large-icon-square:hover {
    .check-off {
      background-image: url('//hm-lis.herokuapp.com/img/svg/check_off_green.svg');
    }
    .check-on {
      background-image: url('//hm-lis.herokuapp.com/img/svg/check_on_green.svg');
    }
  }
  .check-on {
    background-image: url('//hm-lis.herokuapp.com/img/svg/check_on.svg');
  }
  .check-off {
    background-image: url('//hm-lis.herokuapp.com/img/svg/check_off.svg');
  }

</style>
